module.exports = __webpack_public_path__ + "static/launch-42b30a4c69bed808abef0a0107e47490.jpg";